import $ from 'jquery';

const $toggle = $( '.js-offcanvas-toggle' );
const $navigation = $( '.js-offcanvas-navigation' );

if ( $toggle.length ) {
	$toggle.on( 'click', function() {
		$( 'html' ).toggleClass( 'u-overflow-hidden' );
		$( '.c-offcanvas' ).toggleClass( 'is-active' );
	} );

	$navigation.on( 'click', 'a', function ( e ) {
		e.preventDefault();

		$( 'html' ).toggleClass( 'u-overflow-hidden' );
		$( '.c-offcanvas' ).toggleClass( 'is-active' );
		$toggle.toggleClass( 'is-active' );
	} );
}
